/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExtensionOrderStatusDTOFromJSON, ExtensionOrderStatusDTOToJSON, } from './ExtensionOrderStatusDTO';
/**
 * Check if a given object implements the ExtensionOrderStatusBatchResponse interface.
 */
export function instanceOfExtensionOrderStatusBatchResponse(value) {
    return true;
}
export function ExtensionOrderStatusBatchResponseFromJSON(json) {
    return ExtensionOrderStatusBatchResponseFromJSONTyped(json, false);
}
export function ExtensionOrderStatusBatchResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orders': json['orders'] == null ? undefined : (json['orders'].map(ExtensionOrderStatusDTOFromJSON)),
    };
}
export function ExtensionOrderStatusBatchResponseToJSON(json) {
    return ExtensionOrderStatusBatchResponseToJSONTyped(json, false);
}
export function ExtensionOrderStatusBatchResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orders': value['orders'] == null ? undefined : (value['orders'].map(ExtensionOrderStatusDTOToJSON)),
    };
}
